export class Exercise {
    constructor(    
        id=-1, 
        title=''
    ) {
        this.id = id;
        this.title = title;
    }
}
